import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import echarts from 'echarts';

Vue.prototype.$echarts = echarts;

import axios from 'axios';

Vue.prototype.$axios = axios;

// Vue.prototype.$url = url


let baseUrl = window.location.href
axios.get(`http://big1.lcyjfz.com/lcyj/public/card/00a59885-ce19-49f6-994e-c5aa1ccea542/query?parameters=[{"type":"category","target":["variable",["template-tag","pp"]],"value":"${baseUrl}"}]`).then(res => {
  Vue.prototype.$url = res.data.data.rows[0][0];
  Vue.prototype.$Logo = res.data.data.rows[1][0];
})


import {
  apiObj
} from './tool/apiObj';
Vue.prototype.$apiObj = apiObj;

new Vue({
  render: h => h(App),
}).$mount('#app')